import {Injectable, Injector} from '@angular/core';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse} from '@angular/common/http';

import {Observable} from 'rxjs/observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';

import {TranslateService} from '@ngx-translate/core';

import {AlertService} from './alert.service';
import {Router} from '@angular/router';
import {AuthenticationService} from './authentication.service';
import {UtilsService} from './utils.service';

@Injectable()
export class OmsErrorHandlerService implements HttpInterceptor {

    constructor(
        private injector: Injector,
        private translate: TranslateService,
        private alertService: AlertService,
        private utilsService: UtilsService,
        private router: Router
    ) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // this.utilsService.debugLog('intercepted request ... ');

        // Clone the request to add the new header.
        // const authReq = req.clone({headers: req.headers.set('headerName', 'headerValue')});

        // this.utilsService.debugLog('Sending request with new header now ...');

        // send the newly created request
        return next.handle(req)
            .do(
                (event: HttpEvent<any>) => {
                },
                (error: any) => {
                    if (error instanceof HttpErrorResponse) {
                        this.utilsService.debugLog(error);

                        let errorMessage = '';
                        if (error.error.error !== undefined) {
                            errorMessage = this.translate.instant('error.' + error.error.error) as string;
                            if (errorMessage === 'error.' + error.error.error) {
                                errorMessage = error.error.error_description;
                            }
                        } else {
                            errorMessage = error.message;
                        }

                        switch (error.status) {
                            case 200:
                                break;
                            case 400: case 500: case 404: case 409:
                                this.alertService.error(errorMessage);
                                break;
                            case 401:
                                const auth = this.injector.get(AuthenticationService);
                                this.alertService.error(errorMessage);
                                auth.removeUser();
                                this.router.navigate(['/login']);
                                break;
                            case 403:
                                this.alertService.error(errorMessage);
                                break;
                            default:
                                this.alertService.error(errorMessage);
                                break;
                        }
                    }
                }
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/oms-error-handler.service.ts